
<div class="select-contact-search">
    <div class="to-field">
        <mat-form-field class="contact-select" [floatLabel]="'auto'">
          <input
            matInput
            (change)="clearContact()"
            type="object"
            placeholder="To"
            [formControl]="myControl"
            [matAutocomplete]="auto">
          <mat-autocomplete (closed)="dropdownClosed()" #auto="matAutocomplete">
              <mat-option class="contact-option">
                  <button class="jhm-button primary" (click)="showAddContactModal = true">Add New Contact</button>
              </mat-option>
            @for (contact of filteredOptions | async; track contact) {
              <mat-option class="contact-option" (click)="contact.isNew? addContactWithNewEmailWithContext(contact.contactEmailOrBookingNumber) : setSelectedContact(contact)">
                @if (!contact.isNew) {
                  <div class="name-and-id">
                    <div class="name">{{contact.contactFirstName}} {{contact.contactLastName}}</div>
                    @if (contact.contactFirstName || contact.contactLastName) {
                      <div class="id">
                        {{contact.contactType === 'CIVILIAN' ?
                        '(' + contact.contactEmailOrBookingNumber + ')': ''}}
                      </div>
                    }
                    @if (!contact.contactFirstName && !contact.contactLastName) {
                      <div class="id">
                        {{contact.contactEmailOrBookingNumber}}
                      </div>
                    }
                  </div>
                }
                @if (contact.isNew) {
                  <div class="name-and-id">
                    <div class="id">{{contact.contactEmailOrBookingNumber}}</div>
                  </div>
                }
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
</div>
@if (showAddContactModal) {
    <jhm-add-contact (exit)="createContactExit($event)"></jhm-add-contact>
	<!-- <jhm-create-contact (exit)="createContactExit($event)"></jhm-create-contact> -->
}